import { createSelector } from 'reselect';
// Import state types.
import {
	AppState,
	BroadLineOfBusinessState,
	PossiblePerilsState,
} from '@app/redux/states';
// Import props.
import {
	PossiblePerilsProps,
} from '@app/props';
// Import api models.
import {
	PossiblePeril,
} from '@app/models/api';
// Import base selectors.
import {
	getBroadLineOfBusinessState,
} from '@app/redux/selectors/base';

// Fetches the possible perils state.
const getPossiblePerilsState = (state: AppState, props: PossiblePerilsProps): PossiblePerilsState | undefined => {
	let broadLineOfBusinessState: BroadLineOfBusinessState | undefined = getBroadLineOfBusinessState(state, props);
	let stateCode: string = props.stateCode;
	return broadLineOfBusinessState !== undefined
		? broadLineOfBusinessState.possiblePerils[stateCode]
		: undefined;
}

// Get Possible Perils Selector.
const makeGetPossiblePerilsSelector = () => createSelector(
	[getPossiblePerilsState],
	(possiblePerilsState: PossiblePerilsState | undefined): PossiblePeril[] => {
		return possiblePerilsState !== undefined
			? possiblePerilsState.possiblePerils
			: [];
	}
);

// Get Allowed Possible Perils Selector.
const makeGetAllowedPossiblePerilsSelector = () => createSelector(
	[makeGetPossiblePerilsSelector()],
	(possiblePerils: PossiblePeril[]): PossiblePeril[] => {
		return possiblePerils.filter((possiblePeril: PossiblePeril) => possiblePeril.isEligible !== null && possiblePeril.isEligible);
	}
);

// Are Possible Perils Loaded Selector.
const makeArePossiblePerilsLoadedSelector = () => createSelector(
	[getPossiblePerilsState],
	(possiblePerilsState: PossiblePerilsState | undefined): boolean => {
		return possiblePerilsState !== undefined
			? possiblePerilsState.arePossiblePerilsLoaded
			: false;
	}
);


// Export composed methods.
export {
	getPossiblePerilsState,
};

// export selectors.
export {
	makeGetPossiblePerilsSelector,
	makeGetAllowedPossiblePerilsSelector,
	makeArePossiblePerilsLoadedSelector,
};